<div class="container">
  <div class="row mb-5">
    <div class="col-12 col-xl-12">
      <div class="info__box mb-4">
        <div>
          <div class="cont_importante">
            <img src="../../../../../../assets/images/icons/icon-info-box.svg" alt="Importante">
            <div class="tit_info">Importante</div>
          </div>
          <div class="mt-3 mb-2">Para canjear tu cheque regalo de Amazon.es, sigue estos pasos:</div>
          <ol class="mb-3">
            <li>Accede a <a href="https://www.amazon.es/gp/gc/" target="_blank">www.amazon.es/gp/gc/</a></li>
            <li>Si no tienes tu sesión de Amazon abierta accede a “Configuración de la cuenta”. En caso de no estar registrado créate una cuenta Amazon para disfrutar de tu cheque.</li>
            <li>Haz clic en “Canjear tarjeta regalo Amazon”.</li>
            <li>Introduce el código de canje.</li>
            <li>Haz clic en “Canjear”.</li>
            <li>¡Ya puedes comprar con tu nuevo saldo disponible!</li>
          </ol>
          <p>Puede que tengas que introducir tu código de canje del cheque regalo durante el proceso de tramitación del pedido. Para canjear tu cheque regalo utilizando el servicio de pedido en 1-Clic® de Amazon, debes añadir primero el importe del cheque regalo en Tu cuenta.</p>
          <p>Si tienes cualquier pregunta sobre cómo canjear tu cheque regalo, visita <a href="https://www.amazon.es/ayuda" target="_blank">www.amazon.es/ayuda</a> o escribe a través del widget de "Contacto" en MY Posventa.
          </p>
        </div>
      </div>
      <div class="dense__table table-responsive-sm">
        <table id="tblAmazonCard" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table data-tables w-100">
          <thead>
            <tr>
              <th class="text-start" width="92px">Fecha de alta</th>
              <th class="text-start">Animación</th>
              <th class="text-start">Código</th>
              <th class="text-center" width="92px">Importe</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</div>